export default __webpack_public_path__ + "static/media/icon-market-intent-analysis.9989a055.svg";